import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  path {
    transition: all 800ms;
  }
`

export default ({ color1, color2 }) => (
  <Svg width="68" height="64" viewBox="0 0 68 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M30.692 18.31c-2.087 0-3.784 1.669-3.784 3.72v17.214l-.37.195c-2.884 1.514-4.675 4.449-4.675 7.657 0 4.785 3.96 8.677 8.829 8.677 4.868 0 8.829-3.892 8.829-8.677 0-3.208-1.791-6.143-4.675-7.657l-.37-.195V22.03c0-2.05-1.698-3.718-3.784-3.718m0 38.839c-5.641 0-10.23-4.51-10.23-10.054 0-3.579 1.922-6.862 5.044-8.667v-16.4c0-2.81 2.326-5.096 5.186-5.096s5.185 2.287 5.185 5.096v16.4c3.123 1.805 5.045 5.088 5.045 8.667 0 5.544-4.59 10.054-10.23 10.054"
        fill={color1 || '#fff'} />
      <path fill={color1 || '#fff'} d="M29.633 39.511h1.411V21.872h-1.41zM29.986 42.985a3.94 3.94 0 0 0-3.935 3.935 3.94 3.94 0 0 0 3.935 3.934 3.94 3.94 0 0 0 3.935-3.934 3.94 3.94 0 0 0-3.935-3.935m0 9.226a5.298 5.298 0 0 1-5.292-5.291 5.298 5.298 0 0 1 5.292-5.292 5.298 5.298 0 0 1 5.292 5.292 5.298 5.298 0 0 1-5.292 5.291M40.217 29.633h8.466v-1.41h-8.466z"
      />
      <path fill={color1 || '#fff'} d="M43.744 33.161h1.412v-8.467h-1.412zM40.217 36.689h8.466v-1.411h-8.466z"
      />
      <path fill={color2 || '#fff'} d="M61.383 29.633h-1.376v32.49H6.316v-32.49H4.939V63.5h56.444zM33.737 0L0 27.987l.875 1.085L33.731 1.815l33.12 27.818.882-1.08z"
      />
    </g>
  </Svg>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/IconClimate.js